import { Dispatch } from 'redux';
import { Action, AvailableModalActions } from '../store';
import { setModalIsOpen, setModalScreen } from '../actions';

const openPepperContext = () => {
  return async (dispatch: Dispatch<Action>, getState: any) => {
    await dispatch(setModalScreen(AvailableModalActions.SELECT_ACTIONS));
    await dispatch(setModalIsOpen(true));
  };
};

export default openPepperContext;
